import Component from './duplicate_entry_dialog.vue'
export default Component
